import {assert} from 'Asserts';
import {pluralize, prependAOrAn} from 'BenchlingUtil';
import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import strUtil from 'util/strUtil';

export enum ProceduresStringKeys {
  PROCEDURE = 'PROCEDURE',
  METHOD = 'METHOD',
}

export type StringByProcedureStringKey = Record<ProceduresStringKeys, string>;

// Keep in sync with benchling/procedures/domain/utils/name_utils.py
const RecipesStrings: StringByProcedureStringKey = {
  PROCEDURE: 'Recipe',
  METHOD: 'Unit operation',
};

// Keep in sync with benchling/procedures/domain/utils/name_utils.py
const AssaysStrings: StringByProcedureStringKey = {
  PROCEDURE: 'Assay',
  METHOD: 'Unit operation',
};

const StringsByProcedureType: Record<ProcedureType, StringByProcedureStringKey> = {
  [ProcedureType.RECIPE]: RecipesStrings,
  [ProcedureType.ASSAY]: AssaysStrings,
};

export enum StringCase {
  SENTENCE = 'SENTENCE',
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}
interface Settings {
  stringCase?: StringCase;
  plural?: boolean;
  prependAorAn?: boolean;
}

export default function getProcedureUIString(
  key: ProceduresStringKeys,
  procedureType: ProcedureType,
  {stringCase = StringCase.SENTENCE, plural = false, prependAorAn = false}: Settings = {}
): string {
  const titleCaseSingularString = StringsByProcedureType[procedureType][key];
  let uiString = titleCaseSingularString;
  if (plural) {
    uiString = pluralize(2, uiString);
  }
  if (prependAorAn) {
    uiString = prependAOrAn(uiString);
  }
  switch (stringCase) {
    case StringCase.SENTENCE:
      uiString = strUtil.toSentenceCase(uiString);
      break;
    case StringCase.LOWER:
      uiString = uiString.toLowerCase();
      break;
    case StringCase.UPPER:
      uiString = uiString.toUpperCase();
      break;
    default:
      assert(false, 'Invalid stringCase supplied');
  }
  return uiString;
}
